/**
 * "Ödeme al" sihirbazının tek açıcısı (F6.1). Üst bar, Bugün, Kişi dosyası,
 * Programlar ve Tahsilatlar aynı sihirbazı buradan açar; sihirbazın kendisi
 * kabukta bir kez, ilk açılışta yüklenir (payment-host).
 */
import { useSyncExternalStore } from "react";
import type { PaymentPreset } from "./payment-wizard";

interface State {
  open: boolean;
  preset: PaymentPreset | null;
  /** Sihirbaz parçası ilk açılışta yüklenir */
  loaded: boolean;
}

let state: State = { open: false, preset: null, loaded: false };
const subs = new Set<() => void>();
const emit = () => subs.forEach((s) => s());

export const openPaymentWizard = (preset: PaymentPreset = {}) => {
  state = { open: true, preset, loaded: true };
  emit();
};

export const closePaymentWizard = () => {
  state = { ...state, open: false };
  emit();
};

export const usePaymentWizardState = () =>
  useSyncExternalStore(
    (l) => {
      subs.add(l);
      return () => subs.delete(l);
    },
    () => state
  );
